import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-arrangable-selector-menu',
    templateUrl: './arrangable-selector-menu.component.html',
    styleUrls: ['./arrangable-selector-menu.component.scss']
})
export class ArrangableSelectorMenuComponent implements OnInit {

    @Input() public menuOptions: {option: string; selected: boolean}[] = [{option: 'Option 1', selected: true}, {option: 'Option 2', selected: false}];

    @Output() public optionToggled = new EventEmitter<{option: string; selected: boolean}>();
    @Output() public optionMoved = new EventEmitter<{option: string; prevIndex: number; currIndex: number}>();

    public allSelected = false;

    public ngOnInit() {
        this.allSelected = this.menuOptions.length === this.menuOptions.filter(opt => opt.selected).length;
    }

    public drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.menuOptions, event.previousIndex, event.currentIndex);
        this.optionMoved.emit({option: this.menuOptions[event.currentIndex].option, prevIndex: event.previousIndex, currIndex: event.currentIndex});
    }

    public toggleSelect(option: { option: string; selected: boolean }) {
        this.allSelected = false;
        option.selected = !option.selected;
        this.optionToggled.emit(option);
    }

    public selectAll() {
        if (!this.allSelected) {
            this.allSelected = true;
            for (const option of this.menuOptions) {
                option.selected = true;
                this.optionToggled.emit(option);
            }
        } else {
            this.allSelected = false;
            for (const option of this.menuOptions) {
                option.selected = false;
                this.optionToggled.emit(option);
            }
        }
    }
}
